export default {
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  order: {
    icons: {
      dir: {
        asc: ['fal', 'sort-numeric-down'],
        desc: ['fal', 'sort-numeric-up']
      }
    }
  },
  belongs: {
    nagoya: '留学サポート名古屋',
    fukuoka: '留学サポート福岡',
    kumamoto: '留学サポート熊本',
    kagoshima: '留学サポート鹿児島'
  },
  areas: {
    '23': '名古屋',
    '40': '福岡',
    '43': '熊本',
    '46': '鹿児島'
  },
  day: [
    '日', '月', '火', '水', '木', '金', '土'
  ],
  status: {
    answer: {
      yes: 'はい',
      no: 'いいえ'
    },
    onoff: {
      on: 'ON',
      off: 'OFF'
    },
    author: {
      hidden: '非アクティブ',
      active: 'アクティブ',
      suspended: '保留中'
    }
  },
  sex: {
    M: '男性',
    W: '女性'
  },
  nations: {
    JP: '日本',
    TW: '台湾',
    CN: '中国',
    KR: '韓国',
    US: 'アメリカ',
    CA: 'カナダ',
    AU: 'オーストラリア',
    NZ: 'ニュージーランド',
    PH: 'フィリピン',
    GB: 'イギリス',
    FR: 'フランス',
    DE: 'ドイツ',
    CH: 'スイス',
    MT: 'マルタ',
    DK: 'デンマーク',
    SG: 'シンガポール',
    ID: 'インドネシア',
    GU: 'グアム',
    AE: 'UAE'
  },
  contacts: {
    mobile: '携帯電話',
    phone: '固定電話',
    email: 'Eメール'
  },
  prefs: {
    '北海道': '北海道',
    '青森県': '青森県',
    '岩手県': '岩手県',
    '宮城県': '宮城県',
    '秋田県': '秋田県',
    '山形県': '山形県',
    '福島県': '福島県',
    '茨城県': '茨城県',
    '栃木県': '栃木県',
    '群馬県': '群馬県',
    '埼玉県': '埼玉県',
    '千葉県': '千葉県',
    '東京都': '東京都',
    '神奈川県': '神奈川県',
    '山梨県': '山梨県',
    '長野県': '長野県',
    '新潟県': '新潟県',
    '富山県': '富山県',
    '石川県': '石川県',
    '福井県': '福井県',
    '岐阜県': '岐阜県',
    '静岡県': '静岡県',
    '愛知県': '愛知県',
    '三重県': '三重県',
    '滋賀県': '滋賀県',
    '京都府': '京都府',
    '大阪府': '大阪府',
    '兵庫県': '兵庫県',
    '奈良県': '奈良県',
    '和歌山県': '和歌山県',
    '鳥取県': '鳥取県',
    '島根県': '島根県',
    '岡山県': '岡山県',
    '広島県': '広島県',
    '山口県': '山口県',
    '徳島県': '徳島県',
    '香川県': '香川県',
    '愛媛県': '愛媛県',
    '高知県': '高知県',
    '福岡県': '福岡県',
    '佐賀県': '佐賀県',
    '長崎県': '長崎県',
    '熊本県': '熊本県',
    '大分県': '大分県',
    '宮崎県': '宮崎県',
    '鹿児島県': '鹿児島県',
    '沖縄県': '沖縄県'
  },
  passport: {
    status: {
      YES: '所持',
      PROGRESS: '申請中',
      NO: '未所持'
    }
  },
  visa: {
    types: {
      VISIT: '観光',
      STUDENT: '学生',
      WH: 'ワーホリ',
      WK: '就労'
    },
    status: {
      YES: '所持',
      PROGRESS: '申請中',
      NO: '未所持',
      UNNECESSARY: '不要'
    },
    arrangers: {
      AGENT: '代行依頼',
      SELF: '自己手配'
    }
  },
  langs: {
    english: '英語',
    korean: '韓国語',
    chinese: '中国語',
    french: 'フランス語',
    german: 'ドイツ語'
  },
  career: {
    status: {
      graduating: '卒業予定',
      graduated: '卒業済',
      dropped: '中退'
    }
  },
  medical: {
    status: {
      YES: 'はい',
      PAST: '過去にある',
      NO: 'いいえ'
    }
  },
  arrange: {
    types: {
      'prog-short': '短期留学',
      'prog-long': '長期留学',
      'prog-wh': 'ワーホリ',
      'prog-academic': '高校・大学正規留学'
    },
    stay: {
      owners: {
        'nyc-ton': 'NYC-トン',
        'syd-daniel': 'SYD-ダニエル'
      }
    }
  },
  apply: {
    flight: {
      status: {
        ORDER: '当社へ依頼する',
        COMPARE: '比較・検討する',
        SELF: '依頼しない（自己手配）'
      }
    },
    insurance: {
      status: {
        ORDER: '当社へ依頼する',
        COMPARE: '比較・検討する',
        SELF: '依頼しない（自己手配）'
      }
    },
    visa: {
      status: {
        ORDER: '当社手配',
        SELF: '自己手配',
        DONE: '手続き済み',
        SCHOOL: '学校手配',
        UNNECESSARY: '不要'
      }
    },
    pickup: {
      status: {
        SCHOOL: '学校手配',
        SELF: '自己手配',
        THIRD: '外部手配',
        ORDER: '現地サポーター',
        UNNECESSARY: '不要'
      },
      type: {
        oneway: '片道',
        roundtrip: '往復'
      }
    }
  }
}
